import { Application } from "@hotwired/stimulus";
import RailsNestedForm from "@stimulus-components/rails-nested-form";
import AutoSubmit from "@stimulus-components/auto-submit";
import { Autocomplete } from "stimulus-autocomplete";
import Clipboard from "@stimulus-components/clipboard";
import { RailsuiModal } from "railsui-stimulus";

const application = Application.start();
// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

class CustomAutocomplete extends Autocomplete {
  buildURL(query) {
    return `${new URL(this.urlValue, window.location.href).toString()}?q[name_cont]=${query}`;
  }
}

class CustomModal extends RailsuiModal {
  connect() {
    super.connect();
    this.enableAppearance();
    this.toggleTransition();
  }
}
application.register("railsui-modal", CustomModal);
application.register("auto-submit", AutoSubmit);
application.register("nested-form", RailsNestedForm);
application.register("autocomplete", CustomAutocomplete);
application.register("clipboard", Clipboard);
export { application };
